import React, { useEffect, useRef, useState, useCallback } from "react";
import { bootstrapCameraKit } from "@snap/camera-kit";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { getLensIdFromBarcode } from "./barcode";
import brandlogo from "./Powered by Snapchat Branding.png";


const DEFAULT_LENS_ID = "4413b338-743c-4634-bdbd-7d0e9d9e44c0";
const DEFAULT_GROUP_ID = "a0c7f4f8-6ace-4d41-9a3a-f7e4dc2d65bd"
const apiURL = process.env.REACT_APP_API_KEY;

const constraints = {
    video: {
        facingMode: "user",
        aspectRatio: 9 / 16,
        width: { ideal: 1280 },
        height: { ideal: 720 },
        frameRate: { ideal: 30 },
        objectFit: "cover",
    },
};

const Activatelens_2 = () => {
    const [lensLoaded, setLensLoaded] = useState(false);
    const [activeLensId, setActiveLensId] = useState(null);
    const [lensName, setLensName] = useState(null);
    // const [groupId, setGroupId] = useState(null);

    const [searchParams] = useSearchParams();
    // const lensId = searchParams.get("lensId");
    // const groupId = searchParams.get("groupId");
    // const barcode = searchParams.get("barcode") || DEFAULT_LENS_ID;


    const { lensId, groupId, barcode } = useParams();
    const finalBarcode = barcode || DEFAULT_LENS_ID;

    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const snapMediaStreamRef = useRef(null);
    const sessionRef = useRef(null);
    const cameraKitRef = useRef(null);

    const navigate = useNavigate();


    const activateLens = useCallback(async (lensId) => {
        try {
            if (lensLoaded || activeLensId === lensId) {
                console.log(`Lens ${lensId} is already active.`);
                return;
            }

            console.log("Initializing Camera Kit...");

            if (!cameraKitRef.current) {
                cameraKitRef.current = await bootstrapCameraKit({
                    apiToken: apiURL,
                    clientId: "3157d7b6-85ec-440f-bf74-d5ead84bc956", // OAuth 2.0 Public Client ID
                });
            }

            // Device detection
            const userAgent = navigator.userAgent;
            const isTablet = /iPad|Tablet|Android(?!.*Mobile)/i.test(userAgent);
            const isMobile = /iPhone|Android.*Mobile/i.test(userAgent);
            const isDesktop = !isTablet && !isMobile;

            console.log("isTablet:", isTablet);
            console.log("isMobile:", isMobile);
            console.log("isDesktop:", isDesktop);

            // Determine canvas resolution and aspect ratio
            const canvasWidth = isDesktop ? 1280 : isTablet ? 768 : 720;
            const canvasHeight = isDesktop ? 720 : isTablet ? 1024 : 1280;
            const aspectRatio = canvasWidth / canvasHeight;

            // Create or reattach canvas
            const ensureCanvas = () => {
                if (!canvasRef.current) {
                    const canvas = document.createElement("canvas");
                    canvas.id = "my-canvas";
                    canvas.width = canvasWidth;
                    canvas.height = canvasHeight;

                    Object.assign(canvas.style, {
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        transform: "scaleX(-1)",
                    });

                    document.body.appendChild(canvas);
                    canvasRef.current = canvas;
                } else if (!document.body.contains(canvasRef.current)) {
                    document.body.appendChild(canvasRef.current);
                }
            };
            ensureCanvas();

            // Destroy any previous session
            if (sessionRef.current) {
                console.log("Destroying previous session...");
                try {
                    await sessionRef.current.destroy();
                } catch (e) {
                    console.warn("Failed to destroy previous session cleanly:", e);
                }
                sessionRef.current = null;
            }

            // Define session config based on device
            const sessionConfig = {
                liveRenderTarget: canvasRef.current,
                transform: "scaleX(-1)",
                graphicsQuality: isDesktop ? "high" : isTablet ? "medium" : "low",
                enableAudio: false,
                enableVideo: true,
                enableFaceDetection: isMobile || isDesktop,
                enableDepth: false,
                enableDepthOcclusion: false,
                enableFaceOcclusion: isMobile || isTablet,
                enableVideoStabilization: isMobile || isTablet,
                enableFaceTracking: isMobile || isTablet,
                enableHandTracking: false,
                enableBodyTracking: false,
                video: {
                    facingMode: { ideal: ["user"] },
                    frameRate: { ideal: 24 },
                    width: { ideal: 1680 }, // 4K width
                    height: { ideal: 780 }, // 4K height
                },
            };

            // Create new session
            sessionRef.current = await cameraKitRef.current.createSession(sessionConfig);

            // Set up render loop if needed
            const renderLoop = () => {
                sessionRef.current?.render?.();
                requestAnimationFrame(renderLoop);
            };
            requestAnimationFrame(renderLoop);

            // Setup media stream once
            if (!snapMediaStreamRef.current) {
                snapMediaStreamRef.current = await navigator.mediaDevices.getUserMedia({
                    video: sessionConfig.video
                });
            }

            // Bind stream to session
            await sessionRef.current.setSource(snapMediaStreamRef.current);

            // Optional delay for tablets to avoid pipeline stall
            if (isTablet) {
                await new Promise(res => setTimeout(res, 300));
            }

            await sessionRef.current.play();
            console.log("Snap Camera session started.");

            // Load lens
            const currentLens = await cameraKitRef.current.lensRepository.loadLens(lensId, groupId);
            if (!currentLens) throw new Error("Lens could not be loaded! Check Lens ID.");

            console.log(`Applying Lens: ${lensId}`);
            await sessionRef.current.applyLens(currentLens);

            console.log(`Lens ${lensId} activated.`);
            setLensLoaded(true);
            setActiveLensId(lensId);
        } catch (error) {
            console.error("Error activating lens:", error);
        }
    }, [lensLoaded, activeLensId, apiURL, groupId]);




 useEffect(() => {
        const fetchGroupId = async () => {
            if (!finalBarcode) return;
            const data = await getLensIdFromBarcode(finalBarcode);
            setLensName(data.lensName ?? "Default Lens");
        };
        fetchGroupId();
    }, [finalBarcode]);

    useEffect(() => {
        if (lensId && groupId) {
            activateLens(lensId);
        }
    }, [lensId, groupId, activateLens]);


    const stopLens = async () => {
        try {
            navigate(-1);
            // window.close();
        } catch (error) {
            console.error(" Error closing lens:", error);
        }
    };

    return (
        <div
            style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
            }}
        >
            <div style={{
                position: "absolute",
                top: "50px",
                left: "20%",
                transform: "translateX(-50%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "4px 8px",
                zIndex: 10,
                background: "rgba(0, 0, 0, 0.4)",
                borderRadius: "6px",
                fontSize: "13px",
                color: "white",
                fontWeight: "400",
                backdropFilter: "blur(4px)",
                whiteSpace: "nowrap"
            }}>
                {lensName}
            </div>
            <button
                onClick={stopLens}
                style={{
                    position: "absolute",
                    top: "10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    padding: "10px 20px",
                    fontSize: "15px",
                    background: "rgba(0, 0, 0, 0.7)",
                    color: "white",
                    border: "none",
                    borderRadius: "10px",
                    fontWeight: "700",
                    cursor: "pointer",
                    zIndex: 10,
                }}
            >
                Back to Scanning
            </button>
            <img src={brandlogo} alt="Snao_Chat_Logo"
                style={{
                    position: "absolute",
                    bottom: "20px",
                    left: "85%",
                    transform: "translateX(-50%)",
                    width: "120px",
                    zIndex: 10,
                }} />

            <canvas
                ref={canvasRef}
                id="my-canvas"
                style={{
                    height: "100%",
                    width: "100%",
                    // aspectRatio: 16 / 9,
                    // aspectRatio: 9 / 16,
                    frameRate: { ideal: 24 },
                    objectFit: "cover",
                    transform: "scaleX(-1)",
                    // borderRadius: "20px",
                }}
            />
        </div>
    );
};

export default Activatelens_2;
